import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('Environment');
export const EnvironmentProvider = Provider;
export const EnvironmentConsumer = Consumer;
export const EnvironmentContext = Context;
export const useEnvironment = useContext;
//# sourceMappingURL=EnvironmentProvider.js.map